export const MOBILE_DISTANCE_FROM_SEARCH_MODAL_HEADER =
  "Enter name, address, landmark";

export const LOADING_TEXT = "Loading";

export const AUTOCOMPLETE_LABEL = "View distance of this hotel from...";
